import type { PersonView } from "@beacon/core/access"
import { queryOptions } from "@tanstack/react-query"
import { call } from "@/administration/client.ts"

/**
 * Every Member as the signed-in Member may see them: the People page, and every hover card. Kept a
 * few minutes, as people change their Profile rarely.
 */
export const peopleQuery = queryOptions({
  queryKey: ["people", "everyone"],
  queryFn: () => call<{ people: PersonView[] }>("GET", "/people"),
  select: ({ people }) => people,
  staleTime: 5 * 60_000,
})

/** One Member's profile page, as the signed-in Member may see them. */
export const personQuery = (memberId: string) =>
  queryOptions({
    queryKey: ["person", memberId],
    queryFn: () => call<PersonView>("GET", `/people/${memberId}`),
  })
